import doc                     from '@widesk-core/decorators/doc';
import AbstractCachePurgeModel from './AbstractCachePurgeModel';

@doc.urnResource('cache_purge')
export default class CachePurgeModel extends AbstractCachePurgeModel {}
